import axios from "../../../../../utils/authAxios";

const api_base_url =
  process.env.REACT_APP_API_BASEURL + "/OfficeAppliancesTypeConfig";

export const addType = async (newType) => {
  const { data } = await axios.post(`${api_base_url}/AddType`, newType);
  return data;
};
